module.exports = __webpack_public_path__ + "img/arrow-down-02.efc2b84a.svg";